import React from "react";
import "./loading.css";
const Loading = () => {
  return (
    <div className="h-screen loading-container">
      <div class="containerrr">
        <div class="loader1">
          <span></span>
        </div>
        <div class="loader2">
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default Loading;
